import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ContactMessage } from '../contact-models/ContactMessage';
import { ContactService } from '../contact-services/contact.service';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

    messageForm: FormGroup;
    messageErreurPrenomNom: string;
    prenomNomIsValid: boolean;
    messageErreurEmail: string;
    emailIsValid: boolean;
    messageErreurContent: string;
    contentIsValid: boolean

    constructor(private contactService: ContactService, private formBuilder: FormBuilder, private router: Router) { }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.messageForm = this.formBuilder.group({
            firstname: '',
            lastname: '',
            email: ['', [Validators.required, Validators.email]],
            message: ['', [Validators.required]]
        });
    }

    /**
     * Tester si au moins un des 2 champs (firstname, name) est renseigné
     */
    testNomPrenom() {
        if (this.messageForm.value['firstname'] === "" && this.messageForm.value['lastname'] === "") {
            this.prenomNomIsValid = false;
            this.messageErreurPrenomNom = "Au moins un des 2 champs Prénom/Nom doit être renseigné.";
        } else {
            this.prenomNomIsValid = true;
            this.messageErreurPrenomNom = "";
        }
    }

    /**
     * Tester l'email avec une regex et affiche un message d'erreur si besoin
     */
    testEmail() {
        // Récupérer l'email renseigné dans le formulaire
        const email = this.messageForm.value['email'];
        if (email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
            this.messageErreurEmail = "";
            this.emailIsValid = true;
        } else {
            this.messageErreurEmail = "Votre email semble incorect";
            this.emailIsValid = false;
        }
    }

    /**
     * Afficher un message d'erreur si le champs texte du message est vide
     */
    testMessageIsNotEmpty() {
        if (this.messageForm.value['message'] === "") {
            this.contentIsValid = false;
            this.messageErreurContent = "Le champs texte qui contient votre message est vide.";
        } else {
            this.contentIsValid = true;
            this.messageErreurContent = "";
        }
    }

    onSubmitForm() {
        this.testNomPrenom();
        this.testEmail();
        this.testMessageIsNotEmpty();
        if (this.messageErreurPrenomNom === "" && this.messageErreurEmail === "" && this.messageErreurContent === "") {
            const formValue = this.messageForm.value;
            const newMessage = new ContactMessage(
                Date.now(),
                formValue['firstname'],
                formValue['lastname'],
                formValue['email'],
                formValue['message'],
                false
            );
            this.contactService.addMessage(newMessage);
            this.router.navigate(['/contact/confirm'])
        } else {
            console.log("formulaire invalid");
        }
    }
}
